import React from 'react'
import LoginContent from './LoginPage/LoginContent'
import LoginScreen from './LoginScreen'


function LoginPage() {
  return (
    <div>
      <LoginContent />
      {/* <LoginScreen /> */}
    </div>
  )
}

export default LoginPage
